import React from 'react';
import { POINT_ICONS, POINT_ICONS_ACTIVE } from '../../../../constants/defaultValues';

const Icon = ({ iconRef, isActive, className }) => {
    const PointIcon = !isActive ? POINT_ICONS[iconRef] : POINT_ICONS_ACTIVE[iconRef];

    return PointIcon ? <PointIcon className={className} /> : null;
};

export default Icon;
